import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@components/stores-locator/model';
import { Feature } from '@shared/components/map/model';

@Pipe({
  name: 'getMarkers',
  standalone: true,
})
export class GetMarkersPipe implements PipeTransform {
  transform(stores: Store[]): Feature[] {
    return stores.map((store) => ({
      uuid: store.uuid,
      position: new google.maps.LatLng({ lat: store.coords.lat, lng: store.coords.lng }),
    }));
  }
}
